import styled from '@emotion/styled';

export const Icon = styled.svg`
    width: 20px;
    height: 18px;
`;
